
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Multiselect from "vue-multiselect";

@Component({ components: { Multiselect } })
export default class PiSelect extends Vue {
  @Prop({ default: null }) value!: any;
  @Prop({ default: () => [] }) options!: any[];
  @Prop({ default: "value" }) valueField!: string;
  @Prop({ default: "text" }) textField!: string;
  @Prop({ default: "disabled" }) disabledField!: string;
  @Prop({ default: "Select..." }) placeholder!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) clearable!: boolean;
  @Prop({ default: true }) searchable!: boolean;
  @Prop({ default: "md" }) size!: string;
  @Prop({ default: null }) state!: boolean | null;

  // normalize any option shape → { __value, __label, $isDisabled, __placeholder }
  get normalized(): any[] {
    return (this.options || []).map((o) => {
      if (o === null || typeof o !== "object") {
        return { __value: o, __label: String(o), $isDisabled: false };
      }
      const val = this.valueField in o ? o[this.valueField] : o.value;
      const txt = this.textField in o ? o[this.textField] : o.text ?? o.label ?? String(val);
      return {
        __value: val,
        __label: txt === "" || txt == null ? "" : String(txt),
        $isDisabled: !!o[this.disabledField],
        __placeholder: val === null || val === "",
        __raw: o,
      };
    });
  }

  get selected(): any {
    return this.normalized.find((o) => o.__value === this.value) ?? null;
  }

  labelOf(o: any): string {
    return o ? o.__label : "";
  }

  onInput(opt: any): void {
    const v = opt ? opt.__value : null;
    this.$emit("input", v);
    this.$emit("change", v);
  }
}
